import { useRef, useLayoutEffect } from "react";
import { SearchCountResponse } from "../../../../../common/api/decimal/methods/search";
import ListContentResultCard from "../ListContentResultCard";
import { ManageAssetWithLicense } from "../../../../../common/api/decimal/common-types/manageAssets";
import { getFocusableElements } from "../../../../../common/utils/dom";
import { makeSearchReturnDetail, SearchSection } from "../types.ts";

export default function AllContentResultsChunk({
  results,
  openPanel,
}: {
  results: SearchCountResponse[];
  openPanel: (asset: ManageAssetWithLicense, section: SearchSection) => void;
}) {
  const focusRef = useRef<HTMLElement>(null);

  useLayoutEffect(() => {
    if (focusRef.current) {
      getFocusableElements(focusRef.current)[0]?.focus();
    }
  }, [focusRef]);

  return results?.map((result, index) => (
    <ListContentResultCard
      searchResult={result}
      openPanel={openPanel}
      key={result.asset.manageAsset.vbid}
      ref={index === 0 ? focusRef : undefined}
      section={"all"}
      libraryReturn={makeSearchReturnDetail(
        "all",
        result.asset.manageAsset.vbid
      )}
    />
  ));
}
